import { render, staticRenderFns } from "./survey-cdrs.vue?vue&type=template&id=0a052ffa"
import script from "./survey-cdrs.vue?vue&type=script&lang=js"
export * from "./survey-cdrs.vue?vue&type=script&lang=js"
import style0 from "./survey-cdrs.vue?vue&type=style&index=0&id=0a052ffa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports